import React, {useState} from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import FlatButton from "../../DesignSystem/FlatButton";
import InputTextField from "../../DesignSystem/InputTextField";
import {Login} from "../Infrastructure/Auth.presenter";
import Logo from "../../assets/Logo.svg";
import graf from "../../assets/Gafrico.svg";
import graf2 from "../../assets/Grafico2.svg";

import ModalAlert from "../../DesignSystem/ModalAlert";

const inputStyles = {
  "& .MuiInputBase-root": {
    color: "#FFF",
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.primary.main,
    display: "grid",
    gridTemplateColumns: "30% 40% 30%",
    alignItems: "center",
    justifyContent: "center",
    justifyItems: "center",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "space-between",
    },
  },
  container: {
    maxWidth: 480,
    minWidth: 450,
    maxHeight: 600,
    minHeight: 600,
    position: "sticky",
    padding: "30px 15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("xlg")]: {
      minWidth: 400,
      maxWidth: 400,
    },
    [theme.breakpoints.down("md")]: {
      minWidth: 300,
      minHeight: 410,
      maxWidth: 300,
      maxHeight: 410,
    },
  },
  grafico: {
    alignSelf: "flex-start",
    maxHeight: 400,
    minWidth: 350,
    [theme.breakpoints.down("xlg")]: {
      minWidth: 300,
    },
    [theme.breakpoints.down("lg")]: {
      minHeight: 300,
      maxHeight: 250,
      paddingLeft: 40,
    },
    [theme.breakpoints.down("md")]: {
      minHeight: 200,
      alignSelf: "flex-end",
      paddingLeft: 120,
      paddingBottom: 50,
    },
  },
  grafico2: {
    alignSelf: "end",
    maxHeight: 500,
    maxWidth: 500,
    minWidth: 500,
    paddingRight: 40,
    [theme.breakpoints.down("xlg")]: {
      minHeight: 180,
      maxHeight: 200,
      paddingRight: 100,
    },
    [theme.breakpoints.down("lg")]: {
      minHeight: 200,
      maxHeight: 500,
      paddingRight: 140,
    },
    [theme.breakpoints.down("md")]: {
      maxHeight: 150,
      paddingTop: 50,
    },
  },
  link: {
    color: theme.palette.secondary.main,
    fontWeight: 400,
    textDecoration: "none",
    background: "none",
    "&:hover": {
      color: theme.palette.secondary.dark,
    },
  },
  logo: {
    maxWidth: 300,
    maxHeight: 100,
    minWidth: 300,
    minHeight: 100,
    paddingLeft: 15,
    paddingRight: 15,
    [theme.breakpoints.down("md")]: {
      minWidth: 200,
      minHeight: 80,
      maxWidth: 200,
      maxHeight: 80,
    },
  },
  formStyles:{
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 30,
    color: "white",
    flexDirection: "column"
  }
}));

export default function LoginUI() {
  const classes = useStyles();
  const history = useHistory();
  const [values, setValues] = useState({email: "", password:""});
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [sending, setSending] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSending(true);
      const {valid } = await Login(values.email, values.password);
      if(valid) {
        setSending(false);
        history.push("/negocios");
      } else {
        setSending(false);
        setTitleAlert("Usuario o contraseña incorrectos");
        showAlertModal();
      }
    } catch (error) {
      setTitleAlert(error);
      showAlertModal();
    }
  };

  const handleInputChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <Box className={classes.root}>
      <img className={classes.grafico} src={graf} alt="Gráfico uno" />
      <div className={classes.container}>
        <img className={classes.logo} src={Logo} alt="Logo Niku" />
        <form className={classes.formStyles}>
          <InputTextField
            id="email"
            text="Correo electrónico"
            placeholder="email@example.com"
            value={values.email}
            type="text"
            name="email"
            onChange={handleInputChange}
            customStyles={inputStyles}
          />
          <InputTextField
            id="password"
            text="Contraseña"
            placeholder="*******"
            type="password"
            value={values.password}
            onChange={handleInputChange}
            name="password"
            customStyles={inputStyles}
          />

          <Typography variant="subtitle2">
            <Link to="/forgot" className={classes.link}>¿Olvidaste tu contraseña?</Link>
          </Typography>

          <FlatButton
            typeButton="submit"
            title={sending ? "Ingresando..." : "Entrar"}
            widthBtn={"100%"}
            isDisable={sending}
            onClick={handleSubmit}
          />

          <Typography variant="subtitle2" color="#FFF">
            ¿Aún no tienes cuenta?
            <Link
              className={classes.link}
              style={{ marginLeft: 10 }}
              to="/reset"
            >
              Registrate
            </Link>
          </Typography>
        </form>
      </div>

      <img className={classes.grafico2} src={graf2} alt="Gráfico dos" />

      <ModalAlert 
      title={titleAlert} 
      typeAlert={"error"} 
      isOpen={isOpenAlert} 
      handleAlert={handleClickOpen}
      />
    </Box>
  );
}
